import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { ApiMessagesEnum } from '../interfaces/ApiMessagesEnum';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  errorMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  getErrorEnumKeyValue(resp: any): string {
    return Object.keys(ApiMessagesEnum).find(x => ApiMessagesEnum[x] === `${resp.message.toUpperCase()}`);
  }
}
